@if(logData?.action == "LOGIN" || logData?.action == "LOGOUT") {
  <app-login-logout [logData]="logData"></app-login-logout>
}

@if(logData?.action == "CREATE"){
  <app-create-view [logData]="logData"></app-create-view>
}

@if(logData?.action == "UPDATE"){
  <app-update-view [logData]="logData"></app-update-view>
}